export const PATH_HOW_TO_DONATE = `/kaip-galiu-padeti/aukojimas/`;
export const PATH_HOW_TO_VOLUNTEER = `/kaip-galiu-padeti/savanoryste/`;
export const ICON_DONATE = `donate`;
export const ICON_VOLUNTEER = `volunteer`;
export const TEXT_WANT_TO_DONATE = `Noriu aukoti`;
export const TEXT_WANT_TO_VOLUNTEER = `Noriu tapti savanoriu`;
